import { useRef, useState } from 'react';
import { uploadImage, fetchUploads, deleteUpload } from '../../services/adminApi';
import Input from './ui/Input';
import Button from './ui/Button';
import Modal from './ui/Modal';
import ImagePreview from './ui/ImagePreview';
import './AssetField.css';

function AssetField({ label, value, onChange }) {
  const [libraryOpen, setLibraryOpen] = useState(false);
  const [uploads, setUploads] = useState([]);
  const [loadingLibrary, setLoadingLibrary] = useState(false);
  const [dragOver, setDragOver] = useState(false);
  const fileInputRef = useRef(null);

  const openLibrary = async () => {
    setLibraryOpen(true);
    setLoadingLibrary(true);
    try {
      setUploads((await fetchUploads()) || []);
    } finally {
      setLoadingLibrary(false);
    }
  };

  const handleFile = async (file) => {
    if (!file) return;
    const result = await uploadImage(file);
    onChange(result.path);
  };

  const removeUpload = async (upload, event) => {
    event.stopPropagation();
    if (!window.confirm('Supprimer ce fichier de la bibliothèque ?')) return;
    await deleteUpload(upload.id);
    setUploads((prev) => prev.filter((u) => u.id !== upload.id));
  };

  return (
    <div className="admin-field">
      {label && <span>{label}</span>}
      <div
        className={`admin-asset-dropzone ${dragOver ? 'drag-over' : ''}`}
        onDragOver={(e) => {
          e.preventDefault();
          setDragOver(true);
        }}
        onDragLeave={() => setDragOver(false)}
        onDrop={(e) => {
          e.preventDefault();
          setDragOver(false);
          handleFile(e.dataTransfer.files?.[0]);
        }}
        onClick={() => fileInputRef.current?.click()}
      >
        <ImagePreview src={value} />
        <span>Glisser une image ou cliquer pour téléverser</span>
        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          hidden
          onChange={(e) => {
            handleFile(e.target.files?.[0]);
            e.target.value = '';
          }}
        />
      </div>
      <div className="admin-form-inline">
        <Input placeholder={label} value={value || ''} onChange={(e) => onChange(e.target.value)} />
        <Button type="button" variant="secondary" onClick={openLibrary}>
          Bibliothèque
        </Button>
      </div>

      <Modal open={libraryOpen} title="Choisir un fichier" onClose={() => setLibraryOpen(false)}>
        {loadingLibrary ? (
          <p>Chargement...</p>
        ) : uploads.length === 0 ? (
          <p>Aucun fichier dans la bibliothèque.</p>
        ) : (
          <div className="admin-asset-grid">
            {uploads.map((upload) => (
              <div className="admin-asset-item" key={upload.id}>
                <button
                  type="button"
                  className="admin-asset-remove"
                  onClick={(e) => removeUpload(upload, e)}
                  title="Supprimer"
                >
                  ×
                </button>
                <button
                  type="button"
                  className="admin-asset-pick"
                  onClick={() => {
                    onChange(`/uploads/${upload.filename}`);
                    setLibraryOpen(false);
                  }}
                >
                  <ImagePreview src={`/uploads/${upload.filename}`} size={72} />
                  <span className="admin-asset-name" title={upload.originalName}>
                    {upload.originalName}
                  </span>
                </button>
              </div>
            ))}
          </div>
        )}
      </Modal>
    </div>
  );
}

export default AssetField;
